import { isUndefined } from '@aloft/toolkit-shared';

import { Typography } from '../../../summary/components/Typography.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.tsx';
import { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { dollarAndCents } from '../utils/formatters/dollarAndCents.ts';
import { percent } from '../utils/formatters/percent.ts';
import { wholeDollar } from '../utils/formatters/wholeDollar.ts';
import { getTableData } from '../utils/getTableData.ts';

const notApplicableForSubject = ({ compId }: { compId?: string }) => {
  return isUndefined(compId) ? 'surfaceReadonly' : undefined;
};

const tableDef: BreakdownColumn[] = [
  {
    header: 'Size | Location | View',
    type: 'feature',
    adjustmentType: 'site',
    path: 'text',
  },
  {
    header: 'Sale Price',
    type: 'feature',
    adjustmentType: 'site',
    path: 'salePrice',
    valueFormatter: wholeDollar,
    cellColorFormatter: notApplicableForSubject,
  },
  {
    header: '+ Mkt Adj',
    type: 'feature',
    adjustmentType: 'site',
    path: 'marketAdjustment',
    valueFormatter: wholeDollar,
    cellColorFormatter: notApplicableForSubject,
  },
  {
    header: '- Dep Cost',
    type: 'feature',
    adjustmentType: 'site',
    path: 'depreciatedCostOfImprovements',
    valueFormatter: wholeDollar,
  },
  {
    header: '= Site Value*',
    type: 'feature',
    adjustmentType: 'site',
    path: 'siteValue.totalCost',
    valueFormatter: wholeDollar,
    typographyVariant: 'h5',
  },
  {
    header: '= Site / Value',
    type: 'feature',
    adjustmentType: 'site',
    path: 'siteToValueRatio',
    valueFormatter: percent,
  },
  {
    header: '= $ / SF',
    type: 'feature',
    adjustmentType: 'site',
    path: 'siteValue.costPerSqft',
    valueFormatter: dollarAndCents,
  },
  {
    header: 'Adjustment',
    type: 'adjustment',
    adjustmentType: 'site',
    path: 'adjustment',
    valueFormatter: adjustment,
    cellColorFormatter: notApplicableForSubject,
  },
];

export const AdjustmentBreakdownSiteValueTable = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const tableData = getTableData(tableDef, props, props.compSequence);
  return (
    <>
      <SummaryTableHorizontal
        {...props}
        summary={props}
        compSequence={props.compSequence}
        columns={tableDef}
        tableData={tableData}
        subjectHeader="SUB"
        compHeaderPrefix="CP"
      />
      <Typography variant="body2">
        *Site value includes raw land and the as-is value of site improvements such as grading,
        drains, landscaping, paving, and utilities.
      </Typography>
    </>
  );
};
